import React, { useEffect, useState } from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import Cookies from "js-cookie";
import { SettingsAnnouncementBarType } from "@swo/storefront";
import { AnnouncementBar } from "./AnnouncementBar";

const ANNOUNCEMENT_DISMISSED_COOKIE_KEY = `announcement-dismissed`;

export const AnnouncementBarComponent: ReactTFC<{
  announcements: Array<SettingsAnnouncementBarType>;
  positionStatically: boolean;
}> = props => {
  const [visible, setVisible] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);

  const announcementsCombinedId = props.announcements.map(ann => ann.sys.id).join("-");

  const onNotificationDismissed = () => {
    setVisible(false);
    Cookies.set(ANNOUNCEMENT_DISMISSED_COOKIE_KEY, announcementsCombinedId);
  };

  useEffect(() => {
    const maybeAnnouncementId = Cookies.get(ANNOUNCEMENT_DISMISSED_COOKIE_KEY);

    if (maybeAnnouncementId !== announcementsCombinedId) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, []);

  const next = () => {
    setActiveIdx(currIdx => {
      return (currIdx + 1) % props.announcements.length;
    });
  };

  useEffect(() => {
    const id = setTimeout(next, 5000);

    return () => {
      clearTimeout(id);
    };
  }, [activeIdx]);

  return visible && props.announcements.length > 0 ? (
    <AnnouncementBar
      announcements={props.announcements}
      activeIdx={activeIdx}
      onNotificationDismissed={onNotificationDismissed}
      positionStatically={props.positionStatically}
    />
  ) : null;
};
